module.exports = __webpack_public_path__ + "img/background.ae79c965.png";